import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';
import SmoothScroll from '../motion/SmoothScroll';
import CursorGlow from '../motion/CursorGlow';
import ScrollProgress from '../motion/ScrollProgress';
import '../../styles/marketing.css';

// Logged-out web visitors see these routes in the marketing frame (nav +
// footer) instead of the app's sidebar / tab bar.
export const MARKETING_PATHS = ['/', '/faq', '/terms', '/privacy'];
export const isMarketingPath = (pathname) => MARKETING_PATHS.includes(pathname.replace(/\/+$/, '') || '/');

export default function MarketingShell({ children }) {
  const { pathname, hash } = useLocation();

  // New page -> start at the top (hash links scroll themselves).
  useEffect(() => {
    if (hash) return;
    const lenis = window.__pnpLenis;
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="pnp-mkt">
      <SmoothScroll />
      <ScrollProgress />
      <CursorGlow />
      <MarketingNav />
      <main className={`pnp-main${pathname === '/' ? '' : ' pnp-main-page'}`}>{children}</main>
      <MarketingFooter />
    </div>
  );
}
